// Обновить адрес в адресной строке

/**
 * Строка параметров UTM, для добавления к адресу.
 */
let utmParams: string = '';

/**
 * Обновить адрес в адресной строке
 * 
 * @param query Параметры запроса
 */
function updateAddress( query: string ): void
{
	const fullQuery = (
		!utmParams
		? query
		: (
			query
			? `${query}&${utmParams}`
			: utmParams
		)
	);
	
	window.history.replaceState(
		null,
		document.title,
		window.location.pathname + ( fullQuery ? '?' + fullQuery : '' ),
	);
}

/**
 * Устанавливает строку параметров UTM, которая будет добавляться к адресу.
 * 
 * @param parameters Строка параметров UTM.
 */
function setUtmParameters( parameters: string ): void
{
	utmParams = parameters;
}

/**
 * Module
 */
export {
	updateAddress as default,
	setUtmParameters,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/utils/updateAddress.ts